const Pause = ({}) => {
    return null;
};
export function isPauseElement(element) {
    return element.type === Pause;
}
export default Pause;
